import api from './api';

export interface CleanupRoute { id: string; name?: string; [key: string]: unknown }
export interface CleanupPreview { routes: CleanupRoute[]; preserved: number; batches: string[]; after: string | null }
export interface CleanupResult { id: string; status: 'deleted' | 'already_absent' | 'preserved' }

export const samsaraRouteCleanup = {
  async preview(after: string | null): Promise<CleanupPreview> {
    return (await api.post<CleanupPreview>('/admin/samsara-route-cleanup/preview', { after }, { timeout: 60_000 })).data;
  },
  async remove(batch: string): Promise<{ results: CleanupResult[]; error: string | null }> {
    return (await api.post('/admin/samsara-route-cleanup/delete-batch', { batch }, { timeout: 180_000 })).data;
  },
};
